import { URL } from './urls';

export default function getTeleconnectResellers(accesToken, company_id) {
  const apiURL = URL + `/teleconnect_resellers?company_id=${company_id}`

  return fetch(apiURL, {
    headers: {
      'Authorization': `Bearer ${accesToken}`
    }
  })
    .then(res => res.json())
    .then(response => {
      const tempArray = [];
      if (response) {
        if (response.length) {
          response.forEach((element) => {
            const str = element.name.toLowerCase()
            const arr = str.split(" ")
            for (var i = 0; i < arr.length; i++) {
              arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
            }
            const str2 = arr.join(" ")
            tempArray.push({
              label: `${str2}`,
              value: element.id,
            });
          });
        } else {
          tempArray.push({
            label: `${response.name}`,
            value: response.id,
          });
        }
      }
      return tempArray
    })
}